const GET_AGENCIES_QUERY_KEY = ["agencies"];
const GET_USERS_QUERY_KEY = ["users"];
const GET_ROLES_QUERY_KEY = ["roles"];
const GET_PERMISSIONS_QUERY_KEY = ["permissions"];
const GET_TEAM_MEMBERS_QUERY_KEY = ["teamMembers"];
const GET_AD_JOURNEY_QUERY_KEY = ["adJourney"];
const GET_AGENCY_SPRINTS_QUERY_KEY = ["agency_sprints"];
const GET_AD_REQUESTS_QUERY_KEY = ["adRequests"];
const GET_AD_REQUEST_QUERY_KEY = ["adRequest"];
const GET_AD_MODERATIONS_QUERY_KEY = ["adModerations"];
const GET_MODERATION_CONTEXT_QUERY_KEY = ["moderationContext"];
const GET_AD_DELIVERIES_QUERY_KEY = ["adDeliveries"];
const GET_AD_QC_QUERY_KEY = ["adQc"];
const GET_DELIVERY_QUERY_KEY = ["delivery"];
const GET_AD_TYPES_QUERY_KEY = ["adtypes"];
const GET_AD_ADTYPES_QUERY_KEY = ["adAdtypes"];
const GET_RATE_CARDS_QUERY_KEY = ["rateCards"];
const GET_AD_RECCO_QUERY_KEY = ["adRecco"];
const GET_AD_RECCO_DETAIL_QUERY_KEY = ["adReccoDetail"];
const GET_AD_LAUNCHES_QUERY_KEY = ["adLaunches"];
const GET_CATEGORY_TRACK_MAPPINGS_QUERY_KEY = ["category-track-mappings"];
const GET_CTM_OPTIONS_QUERY_KEY = ["ctm-options"];
const GET_META_SYNC_RUNS_QUERY_KEY = ["metaSyncRuns"];
const GET_META_CAMPAIGNS_QUERY_KEY = ["metaCampaigns"];
const GET_TAXONOMY_REVIEW_QUERY_KEY = ["taxonomyReview"];
const GET_TAXONOMY_OPTIONS_QUERY_KEY = ["taxonomyOptions"];

export {
  GET_AGENCIES_QUERY_KEY,
  GET_USERS_QUERY_KEY,
  GET_ROLES_QUERY_KEY,
  GET_PERMISSIONS_QUERY_KEY,
  GET_TEAM_MEMBERS_QUERY_KEY,
  GET_AD_JOURNEY_QUERY_KEY,
  GET_AGENCY_SPRINTS_QUERY_KEY,
  GET_AD_REQUESTS_QUERY_KEY,
  GET_AD_REQUEST_QUERY_KEY,
  GET_AD_MODERATIONS_QUERY_KEY,
  GET_AD_QC_QUERY_KEY,
  GET_MODERATION_CONTEXT_QUERY_KEY,
  GET_AD_DELIVERIES_QUERY_KEY,
  GET_DELIVERY_QUERY_KEY,
  GET_AD_TYPES_QUERY_KEY,
  GET_AD_ADTYPES_QUERY_KEY,
  GET_RATE_CARDS_QUERY_KEY,
  GET_AD_RECCO_QUERY_KEY,
  GET_AD_RECCO_DETAIL_QUERY_KEY,
  GET_AD_LAUNCHES_QUERY_KEY,
  GET_CATEGORY_TRACK_MAPPINGS_QUERY_KEY,
  GET_CTM_OPTIONS_QUERY_KEY,
  GET_META_SYNC_RUNS_QUERY_KEY,
  GET_META_CAMPAIGNS_QUERY_KEY,
  GET_TAXONOMY_REVIEW_QUERY_KEY,
  GET_TAXONOMY_OPTIONS_QUERY_KEY,
};
